import { render, staticRenderFns } from "./ConsumerForward.vue?vue&type=template&id=0efb6c46&scoped=true&"
import script from "./ConsumerForward.vue?vue&type=script&lang=js&"
export * from "./ConsumerForward.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerForward.vue?vue&type=style&index=0&id=0efb6c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb6c46",
  null
  
)

export default component.exports